import '../../reset.css';
import '../../style.css';
import '../../styles/exam/exams.css';
import {userBrowserId} from '../../scripts/common.js';
import {studApi, EVENT_TYPE, TEST_LINK_STATE} from './_studApi.js';
import {ProblemComponent} from './_problemComponent.js';
import {ProblemChat} from './_problemChat.js';
import {renderMath} from '../my_katex.js';
import QRCode from 'qrcode';
import {
    PROCTORING_DEFAULTS,
    captureFrame,
    checkBrowserSupport,
    checkDeviceList,
    checkMultiScreen,
    isBlockedBrowser,
    scheduleScreenShots,
    startAudioCapture,
    startCameraCapture,
    startScreenCapture,
    stopProctoring,
    uploadBlob,
} from './_proctoring.js';
import {createConstructorIframeGuard} from './_constructor_iframe_guard.js';
import {
    scrollToElement,
    cvtTs,
    cvtTsOnlyTime,
    getTimeZone,
    formatTimeRange,
    getDeviceType,
    getBrowserName,
    enterFullscreen,
    getLang,
    pickLangHtml,
} from '../_common/helpers.js';
import {submitConstructorStartForm} from './_constructor_redirect_form.js';
import {initProctoringReadinessQuiz} from './_proctoring_readiness_quiz.js';

studApi.test_event(EVENT_TYPE.PAGE_OPEN);
let link_status;
const isExternalExamPage = document.body?.dataset?.examPage === 'external';

const header = document.getElementById('header');
const header_rep = document.getElementById('header_rep');
const loading = document.getElementById('loading');
const mathTestIntro = document.getElementById('math-test-intro');
const numMinutes = document.getElementById("numMinutes");
const numMinutes2 = document.getElementById("numMinutes2");
const numMinutes3 = document.getElementById("numMinutes3");
const testingTime = document.getElementById("testingTime");
const student_name = document.getElementById("student_name");
const test_name = document.getElementById("test_name");
const start_exam_time = document.getElementById("start_exam_time");
const start_exam_time2 = document.getElementById("start_exam_time2");
const supportChat = document.getElementById("supportChat");
const supportChat2 = document.getElementById("supportChat2");
const error_message_after = document.getElementById("error_message_after");
const tablet_recommendation = document.getElementById("tablet_recommendation");
const yesButton = document.getElementById("yesiam");
const noButton = document.getElementById("notthatsnotme");
const wrongStudentBlock = document.getElementById("wrong-student-alert");
const testRulesBlock = document.getElementById("test-rules");
const acceptCheckbox = document.getElementById("accept-rules");
const acceptPolicy = document.getElementById("accept_policy");
const testInstruction = document.getElementById("test-instructions");
const before_test_start_wrapper = document.getElementById("before_test_start_wrapper");
const readyToStartButton = document.getElementById("ready_to_start");
const ready_button_text = document.getElementById("ready_button_text");
const ready_button_loader = document.getElementById("ready_button_loading");
const proctoringReadinessQuiz = document.getElementById("proctoring_readiness_quiz");
const test_finished = document.getElementById("test_finished");
const written_instuctions = document.getElementById("written_instuctions");
const written_instuctions_after = document.getElementById("written_instuctions_after");
const problems_wrapper = document.getElementById("problems_wrapper");
const qrcode_wrapper = document.getElementById("qrcode_wrapper");
const qrcode_canvas = document.getElementById("qrcode_canvas");
const qrcode_link = document.getElementById("qrcode_link");
const test_status = document.getElementById("test_status");
const student_name2 = document.getElementById("student_name2");
const start_time = document.getElementById("start_time");
const end_time = document.getElementById("end_time");
const time_left = document.getElementById("time_left");
const finish_test = document.getElementById("finish_test");
const finish_modal = document.getElementById("finish_modal");
const cancel_finish = document.getElementById("cancel_finish");
const confirm_finish = document.getElementById("confirm_finish");
let screenStream;
let cameraStream;
let proctoringState = {};
let gostreamingContext = null;
let screenVideoEl = null;
let cameraVideoEl = null;
let cameraPreviewEl = null;
let cameraPreviewWrapper = null;
let cameraPreviewToggle = null;
let cameraPreviewUserHidden = false;
let cameraPreviewForcedHidden = false;
let fullscreenPill = null;
let timerAnimationFrameId = null;
let statusTransitionTimer = null;
let statusRecoveryInProgress = false;
let postFinishMessageBox = null;
let constructorIframeGuard = null;
let constructorFinishPromise = null;
let constructorFinishDone = false;
let constructorProctorStartedSyncPromise = null;
let writtenUploadStatusPollTimer = null;
let constructorIframeContextLogged = false;
const templateHeaderSlots = document.querySelectorAll('[data-template-slot="header"]');
const templateFooterSlots = document.querySelectorAll('[data-template-slot="footer"]');
const ACTIVE_FULLSCREEN_PILL_STATES = new Set([
    TEST_LINK_STATE.STARTED_NOT_FINISHED,
    TEST_LINK_STATE.FIN_WRITTEN_UPLOAD,
]);

function setDisplay(el, value) {
    if (el) {
        el.style.display = value;
    }
}

function setReadyButtonLoading(isLoading) {
    if (!ready_button_loader || !ready_button_text) {
        return;
    }
    if (isLoading) {
        ready_button_text.classList.replace("opacity-100", "opacity-0");
        ready_button_loader.classList.replace("opacity-0", "opacity-100");
    } else {
        ready_button_loader.classList.replace("opacity-100", "opacity-0");
        ready_button_text.classList.replace("opacity-0", "opacity-100");
    }
}

function showStartError(message) {
    if (error_message_after) {
        error_message_after.innerText = message;
        error_message_after.style.display = 'block';
    }
}

function hasConstructorUserAgentHint() {
    try {
        const ua = String(navigator.userAgent || '').toLowerCase();
        const hasConstructor = ua.includes('constructor');
        const hasSecureBrowser = /secure[\s_-]?browser/.test(ua);
        const hasExamusElectron = ua.includes('examus-electron') || (ua.includes('examus') && ua.includes('electron'));
        return hasConstructor || hasSecureBrowser || hasExamusElectron;
    } catch (_) {
        return false;
    }
}

function isConstructorSecureBrowserRuntime(linkState) {
    if (!isConstructorExternalProctoringEnabled(linkState)) {
        return false;
    }
    try {
        const ua = String(navigator.userAgent || '').toLowerCase();
        const hasSecureBrowser = /secure[\s_-]?browser/.test(ua);
        const hasConstructorElectron = ua.includes('constructor') && ua.includes('electron');
        const hasExamusElectron = ua.includes('examus-electron') || (ua.includes('examus') && ua.includes('electron'));
        return hasSecureBrowser || hasConstructorElectron || hasExamusElectron;
    } catch (_) {
        return false;
    }
}

function getAncestorOriginsSnapshot() {
    try {
        const origins = window.location?.ancestorOrigins;
        if (!origins || typeof origins.length !== 'number') {
            return [];
        }
        const out = [];
        for (let i = 0; i < origins.length; i += 1) {
            out.push(String(origins[i]));
        }
        return out;
    } catch (_) {
        return [];
    }
}

function renderConstructorRuntimeDebug(stage = 'unknown', extra = {}) {
    if (!isConstructorExternalProctoringEnabled(link_status)) {
        return;
    }
    const snapshot = {
        stage,
        state: link_status?.state || null,
        need_proctoring: link_status?.need_proctoring,
        provider: link_status?.external_proctoring_provider || null,
        secureBrowserUa: isConstructorSecureBrowserRuntime(link_status),
        hasOriginParam: Boolean(new URLSearchParams(window.location.search).get('examus-client-origin')),
        userAgent: String(navigator.userAgent || ''),
        href: String(window.location.href || ''),
        referrer: String(document.referrer || ''),
        isFramed: (() => {
            try {
                return window.parent !== window;
            } catch (_) {
                return true;
            }
        })(),
        isTopLevel: (() => {
            try {
                return window.self === window.top;
            } catch (_) {
                return false;
            }
        })(),
        ancestorOrigins: getAncestorOriginsSnapshot(),
        ...extra,
    };
    console.log('[Constructor][mathtest] runtime debug snapshot', snapshot);
}

function setProblemsVisible(visible) {
    const display = visible ? 'block' : 'none';
    problems_wrapper.style.display = display;
    templateHeaderSlots.forEach((el) => {
        el.style.display = display;
    });
    templateFooterSlots.forEach((el) => {
        el.style.display = display;
    });
}

function applyTemplateSlots(linkStatus) {
    const lang = getLang() || document.documentElement.lang || 'en';
    const slots = [
        {slot: 'pre-start', value: linkStatus?.pre_start_html},
        {slot: 'header', value: linkStatus?.header_html},
        {slot: 'footer', value: linkStatus?.footer_html},
        {slot: 'post-finish', value: linkStatus?.post_finish_html},
    ];
    slots.forEach((entry) => {
        const html = pickLangHtml(entry.value, lang);
        document.querySelectorAll(`[data-template-slot="${entry.slot}"]`).forEach((el) => {
            el.innerHTML = html || '';
            if (html) {
                renderMath(el);
            }
        });
    });
}

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

function getErrorText(error) {
    if (!error) {
        return 'unknown_error';
    }
    if (error instanceof Error) {
        return error.message || String(error);
    }
    return String(error);
}

function ensurePostFinishMessageBox() {
    if (postFinishMessageBox) {
        return postFinishMessageBox;
    }
    const el = document.createElement('div');
    el.id = 'post_finish_status_message';
    el.style.position = 'fixed';
    el.style.top = '72px';
    el.style.left = '50%';
    el.style.transform = 'translateX(-50%)';
    el.style.zIndex = '9999';
    el.style.maxWidth = '780px';
    el.style.padding = '10px 14px';
    el.style.borderRadius = '8px';
    el.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    el.style.background = '#fff3cd';
    el.style.color = '#7a5b00';
    el.style.fontSize = '14px';
    el.style.display = 'none';
    document.body.appendChild(el);
    postFinishMessageBox = el;
    return el;
}

function showPostFinishMessage(message, isError = false) {
    const box = ensurePostFinishMessageBox();
    box.style.display = 'block';
    box.style.background = isError ? '#fde2e2' : '#fff3cd';
    box.style.color = isError ? '#8d1313' : '#7a5b00';
    box.innerText = message;
}

function hidePostFinishMessage() {
    if (postFinishMessageBox) {
        postFinishMessageBox.style.display = 'none';
        postFinishMessageBox.innerText = '';
    }
}

function clearStatusTransitionTimer() {
    if (statusTransitionTimer) {
        clearTimeout(statusTransitionTimer);
        statusTransitionTimer = null;
    }
}

function clearWrittenUploadStatusPolling() {
    if (writtenUploadStatusPollTimer) {
        clearInterval(writtenUploadStatusPollTimer);
        writtenUploadStatusPollTimer = null;
    }
}

function startWrittenUploadStatusPolling() {
    clearWrittenUploadStatusPolling();
    writtenUploadStatusPollTimer = setInterval(() => {
        if (statusRecoveryInProgress) {
            return;
        }
        if (link_status?.state !== TEST_LINK_STATE.FIN_WRITTEN_UPLOAD) {
            return;
        }
        handlePostExamStatusTransition({forceFinish: false, source: 'written_upload_poll'}).catch((error) => {
            console.error('[Constructor][mathtest] written upload polling failed', error);
        });
    }, 4000);
}


function insertLinkParmsToDom(link_status) {
    const student_first_name = link_status?.student_first_name;
    const student_last_name = link_status?.student_last_name;
    const duration = link_status?.duration;
    if (!student_first_name || !student_last_name || !duration) {
        studApi.redirectToIndex();
    }

    numMinutes.innerText = duration;
    numMinutes2.innerText = duration;
    if (numMinutes3) {
        numMinutes3.innerText = duration;
    }
    testingTime.innerText = formatTimeRange(duration);
    student_name.innerText = `${student_first_name} ${student_last_name}`;
    student_name2.innerText = `${student_first_name} ${student_last_name}`;
    test_name.innerText = link_status?.description || 'unnamed';
    const activeInterval = `${cvtTs(link_status.start_available)}–${cvtTs(link_status.end_available)} (${getTimeZone()})`;
    if (start_exam_time) {
        start_exam_time.innerText = activeInterval;
    }
    if (start_exam_time2) {
        start_exam_time2.innerText = activeInterval;
    }
    applyTemplateSlots(link_status);
}


/**
 * Выходит из полноэкранного режима.
 */
export function exitFullScreen() {
    stopScreenSharing();
    try {
        if (document.exitFullscreen) {
            document.exitFullscreen().catch(e => console.error(e));
        } else if (document.mozCancelFullScreen) { // Firefox
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari и Opera
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
            document.msExitFullscreen();
        }
    } catch (e) {
        console.error(e);
    }
}

function stopScreenSharing() {
    if (screenStream) {
        screenStream.getTracks().forEach(track => {
            track.stop();
            screenStream.removeTrack(track);
        });
        screenStream = null;
    }
}

function stopCameraSharing() {
    if (cameraStream) {
        cameraStream.getTracks().forEach(track => {
            track.stop();
            cameraStream.removeTrack(track);
        });
        cameraStream = null;
    }
}

/*
 ###########################################
 ###########################################
 ###########################################
 ###########################################
 ###########################################
 */

renderMath(document.getElementById("example_with_formula"));

if (getDeviceType() !== 'desktop') {
    tablet_recommendation.style.display = 'block';
}

try {
    link_status = await studApi.get_test_link_status();
} catch (e) {
    console.error(e);
    alert(e + '\nPage will be reloaded in 5 seconds');
    setTimeout(() => {
        location.reload();
    }, 5000);
    throw( e );
}
handleFullscreenChange();
// {
//     "id": 47,
//     "student_first_name": "James",
//     "student_last_name": "Taylor",
//     "school": "Testing",
//     "need_proctoring": 0,
//     "need_mic": 1,
//     "need_screen": 1,
//     "need_camera": 0,
//     "need_answer_input": 1,
//     "start_available": "2025-03-01",
//     "end_available": "2025-06-30",
//     "started_at": null,
//     "finished_at": null,
//     "duration": 90,
//     "state": "not_op",
//     "description": "Internal demo 2y"
// }

loading.style.display = 'none';
insertLinkParmsToDom(link_status);
renderConstructorRuntimeDebug('init_after_get_test_link_status');
initProctoringReadinessQuiz({
    container: proctoringReadinessQuiz,
    startButton: readyToStartButton,
    isEnabled: shouldShowProctoringReadinessQuiz(link_status),
    lang: getLang() || document.documentElement.lang || 'en',
});
const mathTestSupportTestInstanceTaskID = -1000001;
const mathTestSupportTestInstanceTaskID2 = -1000002;
if (!isExternalExamPage) {
    new ProblemChat(supportChat, studApi.token, mathTestSupportTestInstanceTaskID);
    new ProblemChat(supportChat2, studApi.token, mathTestSupportTestInstanceTaskID2);
}

let handledByConstructorIframeBootstrap = false;
if (isConstructorExternalProctoringEnabled(link_status) && isConstructorIframeContext()) {
    try {
        console.log('[Constructor][mathtest] iframe bootstrap flow', {state: link_status?.state});
        if (link_status?.state === TEST_LINK_STATE.NOT_OPENED || link_status?.state === TEST_LINK_STATE.OPENED_NOT_STARTED) {
            await reallyStartTheTest();
            handledByConstructorIframeBootstrap = true;
        } else if (link_status?.state === TEST_LINK_STATE.STARTED_NOT_FINISHED) {
            await showStartedExamView();
            handledByConstructorIframeBootstrap = true;
        } else if (link_status?.state === TEST_LINK_STATE.FIN_WRITTEN_UPLOAD) {
            await handlePostExamStatusTransition({forceFinish: false, source: 'iframe_bootstrap_fin_written_upload'});
            handledByConstructorIframeBootstrap = true;
        } else if (link_status?.state === TEST_LINK_STATE.FINISHED) {
            await handlePostExamStatusTransition({forceFinish: false, source: 'iframe_bootstrap_finished'});
            handledByConstructorIframeBootstrap = true;
        }
    } catch (error) {
        console.error('[Constructor][mathtest] iframe bootstrap failed', error);
    }
}

if (!handledByConstructorIframeBootstrap && (link_status?.state === TEST_LINK_STATE.NOT_OPENED || link_status?.state === TEST_LINK_STATE.OPENED_NOT_STARTED)) {
    mathTestIntro.style.display = 'block';
} else if (!handledByConstructorIframeBootstrap && link_status?.state === TEST_LINK_STATE.STARTED_NOT_FINISHED) {
    studApi.test_event(EVENT_TYPE.OPEN_AFTER_START);
    if (isConstructorExternalProctoringEnabled(link_status) && isConstructorIframeContext()) {
        await showStartedExamView();
    } else if (isExternalExamPage) {
        mathTestIntro.style.display = 'block';
    } else {
        showTimeoutHeader(link_status, true);
        // For Constructor external mode outside iframe we keep the pre-start confirmation flow
        // so user explicitly confirms identity and rules before redirecting back to proctoring page.
        if (!(isConstructorExternalProctoringEnabled(link_status) && !isConstructorIframeContext())) {
            before_test_start_wrapper.style.display = "none";
        }
        mathTestIntro.style.display = 'block';
    }
} else if (!handledByConstructorIframeBootstrap && link_status?.state === TEST_LINK_STATE.FIN_WRITTEN_UPLOAD) {
    studApi.test_event(EVENT_TYPE.OPEN_WRITTEN_UPLOAD);
    if (isConstructorExternalProctoringEnabled(link_status) && !isConstructorIframeContext()) {
        showPostFinishMessage('Re-opening Constructor proctoring session...');
        redirectToConstructorStart().catch((error) => {
            console.error('[Constructor][mathtest] failed to reopen constructor proctoring for FIN_WRITTEN_UPLOAD', error);
            showPostFinishMessage(`Failed to reopen Constructor proctoring: ${getErrorText(error)}`, true);
        });
    } else {
        handlePostExamStatusTransition({forceFinish: false, source: 'page_open_fin_written_upload'}).catch((error) => {
            console.error('[Constructor][mathtest] initial FIN_WRITTEN_UPLOAD transition failed', error);
        });
    }
} else if (!handledByConstructorIframeBootstrap && link_status?.state === TEST_LINK_STATE.FINISHED) {
    studApi.test_event(EVENT_TYPE.OPEN_AFTER_FINISH);
    handlePostExamStatusTransition({forceFinish: false, source: 'page_open_finished'}).catch((error) => {
        console.error('[Constructor][mathtest] initial FINISHED transition failed', error);
    });
} else if (!handledByConstructorIframeBootstrap) {
    studApi.test_event(EVENT_TYPE.UNKOWN_STATE, null, link_status?.state);
    studApi.redirectToIndex();
}


function disableButtons() {
    yesButton.disabled = true;
    noButton.disabled = true;
    yesButton.classList.add("opacity-50", "cursor-not-allowed");
    noButton.classList.add("opacity-50", "cursor-not-allowed");
}


yesButton.addEventListener("click", async () => {
    disableButtons();
    if (isExternalExamPage) {
        studApi.test_event(EVENT_TYPE.THIS_IS_ME);
        setReadyButtonLoading(true);
        await reallyStartTheTest();
        return;
    }
    if (link_status?.state === TEST_LINK_STATE.STARTED_NOT_FINISHED) {
        testInstruction.style.display = 'block';
        scrollToElement(testInstruction);
    } else {
        testRulesBlock.classList.remove("hidden");
        scrollToElement(testRulesBlock);
        studApi.test_event(EVENT_TYPE.THIS_IS_ME);
    }
});

noButton.addEventListener("click", () => {
    disableButtons();
    if (isExternalExamPage) {
        mathTestIntro.style.display = 'none';
    }
    wrongStudentBlock.classList.remove("hidden");
    scrollToElement(wrongStudentBlock);
    studApi.test_event(EVENT_TYPE.NOT_ME);
});


function onAcceptPolicy(ev) {
    if (acceptCheckbox.checked && acceptPolicy.checked) {
        acceptCheckbox.disabled = true;
        acceptPolicy.disabled = true;
        testInstruction.style.display = 'block';
        scrollToElement(testInstruction);
        studApi.test_event(EVENT_TYPE.UNDERSTAND);
    } else {
        testInstruction.style.display = 'none';
    }
}


acceptCheckbox.addEventListener("change", onAcceptPolicy);
acceptPolicy.addEventListener("change", onAcceptPolicy);


let deviceChecked = false;


function screenSharingStopped(ev) {
    studApi.test_event(EVENT_TYPE.SCREEN_STOPPED);
    alert("Screen sharing has been stopped. You must keep screen sharing active to participate in the test.");
    setTimeout(() => {
        location.reload();
    }, 0);
}

function isFlagEnabled(value) {
    return value !== false && value !== 0;
}

function isInternalProctoringEnabled(linkState) {
    if (linkState?.need_proctoring) {
        return false;
    }
    return isFlagEnabled(linkState?.need_screen)
        || isFlagEnabled(linkState?.need_camera)
        || isFlagEnabled(linkState?.need_mic);
}

function isConstructorProvider(linkState) {
    return String(linkState?.external_proctoring_provider || '').toLowerCase() === 'constructor';
}

function isConstructorExternalProctoringEnabled(linkState) {
    return Boolean(linkState?.need_proctoring) && isConstructorProvider(linkState);
}

function isExternalProctoringEnabled(linkState) {
    return isConstructorExternalProctoringEnabled(linkState);
}

function shouldShowProctoringReadinessQuiz(linkState) {
    if (!Boolean(linkState?.need_proctoring)) {
        return false;
    }
    return linkState?.state === TEST_LINK_STATE.NOT_OPENED
        || linkState?.state === TEST_LINK_STATE.OPENED_NOT_STARTED;
}

function getConstructorProctorStartedSyncStorageKey() {
    return `constructor_proctor_started_synced:${studApi.token || ''}`;
}

function isConstructorProctorStartedSynced() {
    try {
        return sessionStorage.getItem(getConstructorProctorStartedSyncStorageKey()) === '1';
    } catch (_) {
        return false;
    }
}

function markConstructorProctorStartedSynced() {
    try {
        sessionStorage.setItem(getConstructorProctorStartedSyncStorageKey(), '1');
    } catch (_) {
        // Ignore storage failures; endpoint remains idempotent on backend side.
    }
}

async function ensureConstructorProctorStartedSynced(source = 'unknown') {
    if (!isConstructorExternalProctoringEnabled(link_status)) {
        return;
    }
    if (!(link_status?.state === TEST_LINK_STATE.STARTED_NOT_FINISHED || link_status?.state === TEST_LINK_STATE.FIN_WRITTEN_UPLOAD)) {
        return;
    }
    if (isConstructorProctorStartedSynced()) {
        return;
    }
    if (constructorProctorStartedSyncPromise) {
        await constructorProctorStartedSyncPromise;
        return;
    }

    constructorProctorStartedSyncPromise = (async () => {
        try {
            const response = await studApi.set_test_link_proctor_started();
            if (response?.status !== 'success') {
                throw new Error(response?.msg || 'set_test_link_proctor_started returned non-success status');
            }
            markConstructorProctorStartedSynced();
            studApi.test_event(EVENT_TYPE.PROCTORED_EXAM_STARTED, null, `constructor:${source}`);
            const refreshedStatus = await studApi.get_test_link_status();
            if (refreshedStatus?.state) {
                link_status = refreshedStatus;
                handleFullscreenChange();
            }
            console.log('[Constructor][mathtest] proctor_started synced', {
                source,
                state: link_status?.state,
                started_at: link_status?.started_at,
            });
        } catch (error) {
            console.error('[Constructor][mathtest] failed to sync proctor_started', {
                source,
                error: getErrorText(error),
            });
            studApi.test_event(EVENT_TYPE.PROCTORING_START, null, `constructor_sync_failed:${source}:${getErrorText(error)}`);
        } finally {
            constructorProctorStartedSyncPromise = null;
        }
    })();
    await constructorProctorStartedSyncPromise;
}

function shouldManageFullscreenByHost(linkState) {
    return !isExternalProctoringEnabled(linkState);
}

function shouldActivateConstructorIframeGuard(linkState) {
    if (!isConstructorExternalProctoringEnabled(linkState)) {
        return false;
    }
    if (isConstructorSecureBrowserRuntime(linkState)) {
        // In Constructor Secure Browser the exam can be opened top-level (not iframe),
        // so iframe handshake guard is not applicable.
        return false;
    }
    if (isConstructorIframeContext()) {
        return true;
    }
    return linkState?.state === TEST_LINK_STATE.STARTED_NOT_FINISHED
        || linkState?.state === TEST_LINK_STATE.FIN_WRITTEN_UPLOAD;
}

function ensureConstructorIframeGuardInitialized(linkState) {
    if (constructorIframeGuard) {
        return constructorIframeGuard;
    }
    if (!shouldActivateConstructorIframeGuard(linkState)) {
        return null;
    }

    constructorIframeGuard = createConstructorIframeGuard({
        enabled: true,
        timeoutMs: 20000,
        assessCode: String(linkState?.test_link_id || linkState?.id || ''),
        onStateChange: (state) => {
            console.log('[Constructor][mathtest] iframe guard state', state);
            renderConstructorRuntimeDebug('iframe_guard_state', {
                guardState: state,
            });
        },
    });
    return constructorIframeGuard;
}

async function ensureConstructorIframeGuardReady(source = 'unknown') {
    const guard = ensureConstructorIframeGuardInitialized(link_status);
    if (!guard) {
        return true;
    }
    const ready = await guard.waitUntilReady();
    if (ready) {
        return true;
    }
    const guardError = guard.getError();
    const errorMessage = guardError?.message || 'Constructor proctoring context validation failed';
    showPostFinishMessage(errorMessage, true);
    error_message_after.innerText = `External Proctoring Error: ${errorMessage}`;
    error_message_after.style.display = 'block';
    studApi.test_event(EVENT_TYPE.PROCTORING_SCREENSHOT_FAIL, null, `${source}:${errorMessage}`);
    return false;
}

async function ensureConstructorSessionFinishedByLms(source = 'unknown') {
    if (!isConstructorExternalProctoringEnabled(link_status)) {
        return {status: 'skipped'};
    }
    if (constructorFinishDone) {
        return {status: 'already_finished'};
    }
    if (constructorFinishPromise) {
        return await constructorFinishPromise;
    }

    constructorFinishPromise = (async () => {
        const maxAttempts = 6;
        let lastError = null;
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
            try {
                showPostFinishMessage(`Finalizing external proctoring session (${attempt}/${maxAttempts})...`);
                const response = await studApi.finish_constructor_session_by_lms();
                const isOk = response?.status === 'success';
                if (!isOk) {
                    throw new Error(response?.msg || 'Constructor finish endpoint returned non-success response');
                }
                constructorFinishDone = true;
                studApi.test_event(EVENT_TYPE.PROCTORING_STOP, null, `constructor_finish:${response?.finishResult || 'ok'}:${source}`);
                hidePostFinishMessage();
                return response;
            } catch (error) {
                lastError = error;
                const msg = getErrorText(error);
                showPostFinishMessage(
                    `Waiting for Constructor finish synchronization (${attempt}/${maxAttempts}): ${msg}`,
                    true
                );
                if (attempt < maxAttempts) {
                    await sleep(Math.min(attempt * 1500, 5000));
                }
            }
        }
        throw new Error(`Constructor finish failed after ${maxAttempts} attempts: ${getErrorText(lastError)}`);
    })().finally(() => {
        constructorFinishPromise = null;
    });

    return await constructorFinishPromise;
}

function logInteractionDiagnostics(reason = 'unknown') {
    const active = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const centerX = Math.floor(window.innerWidth / 2);
    const centerY = Math.floor(window.innerHeight / 2);
    const stack = (document.elementsFromPoint(centerX, centerY) || []).slice(0, 6).map((el) => {
        const style = window.getComputedStyle(el);
        return {
            tag: el.tagName,
            id: el.id || '',
            className: el.className || '',
            pointerEvents: style.pointerEvents,
            display: style.display,
            visibility: style.visibility,
            position: style.position,
            zIndex: style.zIndex,
            ariaHidden: el.getAttribute?.('aria-hidden'),
        };
    });
    console.log('[Constructor][mathtest] Interaction diagnostics', {
        reason,
        activeTag: active?.tagName || null,
        activeId: active?.id || null,
        activeClassName: active?.className || null,
        fullscreenElement: document.fullscreenElement?.tagName || null,
        centerPoint: {x: centerX, y: centerY},
        topElementsAtCenter: stack,
    });
}

function showProctoringError(message, eventType = null, additionalInfo = null) {
    if (eventType) {
        studApi.test_event(eventType, null, additionalInfo || '');
    }
    stopScreenSharing();
    alert(message);
}

function shouldAutoHidePreview() {
    return window.innerWidth < 900 || window.innerHeight < 600;
}

function applyCameraPreviewVisibility() {
    cameraPreviewForcedHidden = shouldAutoHidePreview();
    const shouldHide = cameraPreviewForcedHidden || cameraPreviewUserHidden;
    if (cameraPreviewWrapper) {
        cameraPreviewWrapper.style.display = shouldHide ? 'none' : 'block';
    }
    if (cameraPreviewToggle) {
        cameraPreviewToggle.style.display = shouldHide ? 'flex' : 'none';
    }
}

function createCameraPreviewControls() {
    if (!cameraPreviewWrapper) {
        cameraPreviewWrapper = document.createElement('div');
        cameraPreviewWrapper.className = 'proctoring-preview';
        const hideButton = document.createElement('button');
        hideButton.type = 'button';
        hideButton.textContent = 'Hide';
        hideButton.addEventListener('click', () => {
            cameraPreviewUserHidden = true;
            applyCameraPreviewVisibility();
        });
        cameraPreviewWrapper.appendChild(hideButton);
        document.body.appendChild(cameraPreviewWrapper);
    }

    if (!cameraPreviewToggle) {
        cameraPreviewToggle = document.createElement('button');
        cameraPreviewToggle.type = 'button';
        cameraPreviewToggle.className = 'proctoring-preview-toggle';
        cameraPreviewToggle.textContent = 'Camera';
        cameraPreviewToggle.addEventListener('click', () => {
            cameraPreviewUserHidden = false;
            applyCameraPreviewVisibility();
        });
        document.body.appendChild(cameraPreviewToggle);
    }
}

function setupCameraPreview(stream) {
    createCameraPreviewControls();
    if (!cameraPreviewEl) {
        cameraPreviewEl = document.createElement('video');
        cameraPreviewEl.muted = true;
        cameraPreviewEl.playsInline = true;
        cameraPreviewEl.autoplay = true;
        cameraPreviewWrapper.appendChild(cameraPreviewEl);
    }
    cameraPreviewEl.srcObject = stream;
    cameraPreviewEl.play().catch(() => {});
    applyCameraPreviewVisibility();
}

function teardownCameraPreview() {
    if (cameraPreviewEl) {
        cameraPreviewEl.srcObject = null;
        cameraPreviewEl.remove();
        cameraPreviewEl = null;
    }
    if (cameraPreviewWrapper) {
        cameraPreviewWrapper.remove();
        cameraPreviewWrapper = null;
    }
    if (cameraPreviewToggle) {
        cameraPreviewToggle.remove();
        cameraPreviewToggle = null;
    }
    cameraPreviewUserHidden = false;
    cameraPreviewForcedHidden = false;
}

function shouldShowFullscreenPill(linkState) {
    if (!linkState || !linkState.state) {
        return false;
    }
    if (isConstructorSecureBrowserRuntime(linkState)) {
        return false;
    }
    if (!shouldManageFullscreenByHost(linkState)) {
        return false;
    }
    return ACTIVE_FULLSCREEN_PILL_STATES.has(linkState.state);
}

function ensureFullscreenPill() {
    if (!shouldShowFullscreenPill(link_status)) {
        return;
    }
    if (!fullscreenPill) {
        fullscreenPill = document.createElement('button');
        fullscreenPill.type = 'button';
        fullscreenPill.className = 'proctoring-fullscreen-pill';
        fullscreenPill.textContent = 'Return to fullscreen';
        fullscreenPill.addEventListener('click', () => {
            enterFullscreen();
        });
        document.body.appendChild(fullscreenPill);
    }
    fullscreenPill.style.display = document.fullscreenElement ? 'none' : 'flex';
}

function handleFullscreenChange() {
    if (!shouldShowFullscreenPill(link_status)) {
        if (fullscreenPill) {
            fullscreenPill.style.display = 'none';
        }
        return;
    }
    if (!fullscreenPill) {
        ensureFullscreenPill();
    }
    if (fullscreenPill) {
        fullscreenPill.style.display = document.fullscreenElement ? 'none' : 'flex';
    }
}

async function prepareInternalProctoring(linkState) {
    const blocked = isBlockedBrowser();
    if (blocked.blocked) {
        showProctoringError(
            'Sorry, in your browser we cannot verify that you are sharing the full screen.',
            EVENT_TYPE.PROCTORING_UNSUPPORTED_BROWSER,
            blocked.reason,
        );
        return false;
    }

    const support = checkBrowserSupport();
    if (!support.ok) {
        showProctoringError(
            'Sorry, in your browser we cannot verify that you are sharing the full screen.',
            EVENT_TYPE.PROCTORING_UNSUPPORTED_BROWSER,
            support.reason,
        );
        return false;
    }

    if (isFlagEnabled(linkState?.need_screen)) {
        const screenCheck = await checkMultiScreen();
        if (!screenCheck.ok) {
            const isUnsupported = ['screen_details_missing', 'screen_details_error'].includes(screenCheck.reason);
            if (isUnsupported) {
                studApi.test_event(
                    EVENT_TYPE.PROCTORING_UNSUPPORTED_BROWSER,
                    null,
                    screenCheck.reason,
                );
                return true;
            }
            showProctoringError(
                'We detected multiple monitors. Please disconnect extra displays to continue.',
                EVENT_TYPE.PROCTORING_SECOND_MONITOR,
                JSON.stringify(screenCheck),
            );
            return false;
        }
    }

    if (isFlagEnabled(linkState?.need_camera)) {
        const deviceCheck = await checkDeviceList();
        if (!deviceCheck.ok) {
            showProctoringError(
                `Virtual camera detected. Please disable it: ${deviceCheck.blocked.join(', ')}`,
                EVENT_TYPE.PROCTORING_CAMERA_FAIL,
                deviceCheck.blocked.join(','),
            );
            return false;
        }
    }

    try {
        gostreamingContext = await studApi.get_gostreaming_token();
    } catch (e) {
        gostreamingContext = null;
        studApi.test_event(EVENT_TYPE.PROCTORING_SCREENSHOT_FAIL, null, 'token_fetch_failed');
    }
    return true;
}

async function ensureGostreamingContext() {
    if (gostreamingContext) {
        return true;
    }
    try {
        gostreamingContext = await studApi.get_gostreaming_token();
        return true;
    } catch (e) {
        studApi.test_event(EVENT_TYPE.PROCTORING_SCREENSHOT_FAIL, null, 'token_fetch_failed');
        return false;
    }
}

function ensureHiddenVideo(existing, stream) {
    let video = existing;
    if (!video) {
        video = document.createElement('video');
        video.muted = true;
        video.playsInline = true;
        video.autoplay = true;
        video.style.display = 'none';
        document.body.appendChild(video);
    }
    video.srcObject = stream;
    return video;
}

async function ensureScreenCapture() {
    if (screenStream) {
        const track = screenStream.getVideoTracks()[0];
        const settings = track?.getSettings?.() || {};
        if (settings.displaySurface && settings.displaySurface !== 'monitor') {
            throw new Error('display_surface_not_monitor');
        }
        return {stream: screenStream, track};
    }
    const res = await startScreenCapture({onEnded: screenSharingStopped});
    screenStream = res.stream;
    return res;
}

async function ensureCameraCapture() {
    if (cameraStream) {
        const track = cameraStream.getVideoTracks()[0];
        return {stream: cameraStream, track};
    }
    const res = await startCameraCapture();
    cameraStream = res.stream;
    return res;
}

function buildUploadParams(type) {
    return {
        baseUrl: gostreamingContext?.gostreaming_base_url || '/gostreamer',
        examId: gostreamingContext?.exam_id,
        userId: gostreamingContext?.user_id,
        jwt: gostreamingContext?.jwt,
        type,
    };
}

async function uploadSnapshot(type, blob) {
    if (!gostreamingContext) {
        const ok = await ensureGostreamingContext();
        if (!ok) {
            throw new Error('gostreaming_unavailable');
        }
    }
    const params = buildUploadParams(type);
    const ts = new Date().toISOString();
    return uploadBlob({
        ...params,
        blob,
        ts,
    });
}

async function startInternalProctoring(linkState) {
    if (proctoringState.started) {
        return;
    }
    proctoringState.started = true;
    await ensureGostreamingContext();
    studApi.test_event(EVENT_TYPE.PROCTORING_START);

    if (isFlagEnabled(linkState?.need_screen)) {
        try {
            const {stream} = await ensureScreenCapture();
            proctoringState.screenStream = stream;
            screenVideoEl = ensureHiddenVideo(screenVideoEl, stream);
            await screenVideoEl.play();
            proctoringState.screenSchedule = scheduleScreenShots({
                captureFn: async () => {
                    const blob = await captureFrame(
                        screenVideoEl,
                        PROCTORING_DEFAULTS.screenWidth,
                        PROCTORING_DEFAULTS.screenQuality,
                    );
                    if (!blob) {
                        throw new Error('screen_blob_empty');
                    }
                    await uploadSnapshot('screen', blob);
                    studApi.test_event(EVENT_TYPE.PROCTORING_SCREENSHOT_OK);
                },
                onError: (err) => {
                    studApi.test_event(EVENT_TYPE.PROCTORING_SCREENSHOT_FAIL, null, String(err));
                },
            });
        } catch (error) {
            if (String(error?.message || error) === 'display_surface_not_monitor') {
                showProctoringError(
                    'Please share the entire screen (not a window or a tab).',
                    EVENT_TYPE.PROCTORING_SCREEN_NOT_MONITOR,
                );
            } else {
                studApi.test_event(EVENT_TYPE.PROCTORING_SCREENSHOT_FAIL, null, String(error));
            }
        }
    }

    if (isFlagEnabled(linkState?.need_camera)) {
        try {
            const {stream} = await ensureCameraCapture();
            proctoringState.cameraStream = stream;
            cameraVideoEl = ensureHiddenVideo(cameraVideoEl, stream);
            setupCameraPreview(stream);
            await cameraVideoEl.play();

            for (let i = 0; i < 3; i += 1) {
                const blob = await captureFrame(cameraVideoEl, PROCTORING_DEFAULTS.cameraWidth, 0.95);
                if (blob) {
                    await uploadSnapshot('camera', blob);
                }
                await new Promise(resolve => setTimeout(resolve, 400));
            }

            proctoringState.cameraTimer = setInterval(async () => {
                try {
                    const blob = await captureFrame(
                        cameraVideoEl,
                        PROCTORING_DEFAULTS.cameraWidth,
                        PROCTORING_DEFAULTS.cameraQuality,
                    );
                    if (!blob) {
                        throw new Error('camera_blob_empty');
                    }
                    await uploadSnapshot('camera', blob);
                    studApi.test_event(EVENT_TYPE.PROCTORING_CAMERA_OK);
                } catch (err) {
                    studApi.test_event(EVENT_TYPE.PROCTORING_CAMERA_FAIL, null, String(err));
                }
            }, PROCTORING_DEFAULTS.screenIntervalMs);
        } catch (error) {
            studApi.test_event(EVENT_TYPE.PROCTORING_CAMERA_FAIL, null, String(error));
        }
    }

    if (isFlagEnabled(linkState?.need_mic)) {
        try {
            const {stream, recorder} = await startAudioCapture({
                onData: async (chunk) => {
                    try {
                        await uploadSnapshot('audio', chunk);
                        studApi.test_event(EVENT_TYPE.PROCTORING_AUDIO_OK);
                    } catch (err) {
                        studApi.test_event(EVENT_TYPE.PROCTORING_AUDIO_FAIL, null, String(err));
                    }
                },
            });
            proctoringState.audioStream = stream;
            proctoringState.audioRecorder = recorder;
            recorder.start(PROCTORING_DEFAULTS.audioChunkMs);
        } catch (error) {
            studApi.test_event(EVENT_TYPE.PROCTORING_AUDIO_FAIL, null, String(error));
        }
    }
}

function stopInternalProctoring() {
    if (proctoringState.cameraTimer) {
        clearInterval(proctoringState.cameraTimer);
        proctoringState.cameraTimer = null;
    }
    stopProctoring(proctoringState);
    proctoringState = {};
    screenStream = null;
    cameraStream = null;
    teardownCameraPreview();
    studApi.test_event(EVENT_TYPE.PROCTORING_STOP);
}


async function checkMediaDevices() {
    if (deviceChecked) {
        return true;
    }
    try {
        // Запрашиваем доступ к экрану
        if (link_status?.need_screen !== false && link_status?.need_screen !== 0) {
            try {
                screenStream = await navigator.mediaDevices.getDisplayMedia({video: {displaySurface: "monitor"}});
                // Отслеживаем остановку трансляции экрана
                const screenTrack = screenStream.getVideoTracks()[0];
                if (screenTrack) {
                    const settings = screenTrack.getSettings?.() || {};
                    if (settings.displaySurface && settings.displaySurface !== 'monitor') {
                        screenStream.getTracks().forEach(track => track.stop());
                        screenStream = null;
                        showProctoringError(
                            'Please share the entire screen (not a window or a tab).',
                            EVENT_TYPE.PROCTORING_SCREEN_NOT_MONITOR,
                        );
                        return false;
                    }
                    screenTrack.addEventListener("ended", screenSharingStopped);
                }
                enterFullscreen();
                studApi.test_event(EVENT_TYPE.SCREEN_OK);
            } catch (error) {
                studApi.test_event(EVENT_TYPE.SCREEN_FAIL);
                alert("Screen sharing access is required to participate in the test.\n" +
                    "It might be not working on tablets and smartphones because they cannot share screen to browser.\n" +
                    "\n" +
                    "If you are using MacOS:\n" +
                    "\n" +
                    "Open System Settings (or System Preferences on older macOS versions).\n" +
                    "Go to Privacy & Security → Screen Recording.\n" +
                    "Ensure Safari (or your browser) is checked. \n" +
                    "\n" +
                    "If share screen prompt does not appear, check page security set up under the lock sign left to the url.\n" +
                    "Or try to check the same on chrome/opera/firefox browser.");
                return false;
            }
        }

        if (link_status?.need_camera !== false && link_status?.need_camera !== 0) {
            try {
                const {stream} = await startCameraCapture();
                cameraStream = stream;
                studApi.test_event(EVENT_TYPE.PROCTORING_CAMERA_OK);
            } catch (error) {
                studApi.test_event(EVENT_TYPE.PROCTORING_CAMERA_FAIL, null, String(error));
                stopScreenSharing();
                stopCameraSharing();
                const browser = getBrowserName();
                alert(
                    `Camera access is required to participate in the test.\n\n` +
                    `How to enable camera access in ${browser}:\n\n` +
                    (browser === "Google Chrome"
                        ? `1. Click on the lock icon 🔒 in the address bar.\n2. Find "Camera" and set it to "Allow".\n3. Refresh the page and try again.`
                        : browser === "Mozilla Firefox"
                            ? `1. Click on the camera icon in the address bar.\n2. Select "Allow" to enable camera access.\n3. Refresh the page and try again.`
                            : browser === "Safari"
                                ? `1. Go to "Safari" > "Settings for This Website".\n2. Find "Camera" and set it to "Allow".\n3. Refresh the page and try again.`
                                : browser === "Microsoft Edge"
                                    ? `1. Click on the lock icon 🔒 in the address bar.\n2. Find "Camera" and set it to "Allow".\n3. Refresh the page and try again.`
                                    : browser === "Opera"
                                        ? `1. Click on the lock icon 🔒 in the address bar.\n2. Find "Camera" and set it to "Allow".\n3. Refresh the page and try again.`
                                        : `1. Check your browser settings for camera permissions.\n2. Allow camera access and refresh the page.`)
                );
                return false;
            }
        }

        // Проверяем наличие микрофона
        if (link_status?.need_mic !== false && link_status?.need_mic !== 0) {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const hasMicrophone = devices.some(device => device.kind === "audioinput");

            if (!hasMicrophone) {
                studApi.test_event(EVENT_TYPE.MIC_FAIL);
                stopScreenSharing();
                stopCameraSharing();
                alert("No microphone detected. A microphone is required to participate in the test.");
                return false;
            }

            // Запрашиваем доступ к микрофону
            try {
                await navigator.mediaDevices.getUserMedia({audio: true});
            } catch (error) {
                studApi.test_event(EVENT_TYPE.MIC_FAIL);
                stopScreenSharing();
                stopCameraSharing();
                const browser = getBrowserName();
                alert(
                    `Microphone access is required to participate in the test.\n\n` +
                    `How to enable microphone access in ${browser}:\n\n` +
                    (browser === "Google Chrome"
                        ? `1. Click on the lock icon 🔒 in the address bar.\n2. Find "Microphone" and set it to "Allow".\n3. Refresh the page and try again.`
                        : browser === "Mozilla Firefox"
                            ? `1. Click on the microphone icon in the address bar.\n2. Select "Allow" to enable microphone access.\n3. Refresh the page and try again.`
                            : browser === "Safari"
                                ? `1. Go to "Safari" > "Settings for This Website".\n2. Find "Microphone" and set it to "Allow".\n3. Refresh the page and try again.`
                                : browser === "Microsoft Edge"
                                    ? `1. Click on the lock icon 🔒 in the address bar.\n2. Find "Microphone" and set it to "Allow".\n3. Refresh the page and try again.`
                                    : browser === "Opera"
                                        ? `1. Click on the lock icon 🔒 in the address bar.\n2. Find "Microphone" and set it to "Allow".\n3. Refresh the page and try again.`
                                        : `1. Check your browser settings for microphone permissions.\n2. Allow microphone access and refresh the page.`)
                );
                return false;
            }
            studApi.test_event(EVENT_TYPE.MIC_OK);
        }

        deviceChecked = true;
        return true;
    } catch (error) {
        console.error("Error checking media devices:", error);
        stopScreenSharing();
        stopCameraSharing();
        alert("An error occurred while checking media device permissions.");
        return false;
    }
}


async function prcReadyToStart(ev) {
    if (shouldManageFullscreenByHost(link_status) && !isFlagEnabled(link_status?.need_screen)) {
        enterFullscreen();
    }
    ready_button_text.classList.replace("opacity-100", "opacity-0"); // Скрываем текст кнопки
    ready_button_loader.classList.replace("opacity-0", "opacity-100"); // Показываем лоадер
    const mediaReady = await checkMediaDevices();
    studApi.test_event(EVENT_TYPE.READY_TO_START);
    if (!mediaReady) {
        ready_button_loader.classList.replace("opacity-100", "opacity-0"); // Скрываем текст кнопки
        ready_button_text.classList.replace("opacity-0", "opacity-100"); // Показываем лоадер
    } else {
        if (isInternalProctoringEnabled(link_status)) {
            const prepared = await prepareInternalProctoring(link_status);
            if (!prepared) {
                ready_button_loader.classList.replace("opacity-100", "opacity-0"); // Скрываем текст кнопки
                ready_button_text.classList.replace("opacity-0", "opacity-100"); // Показываем лоадер
                return;
            }
        }
        await reallyStartTheTest();
    }
}


readyToStartButton.addEventListener("click", prcReadyToStart);
problems_wrapper.addEventListener("pointerdown", (ev) => {
    if (!shouldManageFullscreenByHost(link_status)) {
        return;
    }
    if (document.fullscreenElement) {
        return;
    }
    const target = ev.target;
    const isInput = target instanceof HTMLInputElement
        || target instanceof HTMLTextAreaElement
        || target?.isContentEditable;
    if (isInput) {
        enterFullscreen();
    }
});

async function showQRcode() {
    showTimeoutHeader(link_status, true);
    loading.style.display = 'none';
    mathTestIntro.style.display = 'none';
    testInstruction.style.display = 'none';
    testRulesBlock.style.display = 'none';
    setProblemsVisible(false);
    setDisplay(test_finished, 'none');
    setDisplay(qrcode_wrapper, 'block');
    finish_test.style.display = 'none';
    if (!qrcode_canvas || !qrcode_link) {
        console.warn('[mathtest] QR upload elements are missing on this page');
        return;
    }
    const uploadUrl = window.location.href.replace(/exam\/\w+/, 'exam/writtenupload').replace(/\&startExam=\w+/, '');

    QRCode.toCanvas(qrcode_canvas, uploadUrl, {errorCorrectionLevel: 'H'}, function (error) {
        if (error) console.error(error);
        console.log('success!');
    });
    qrcode_link.textContent = uploadUrl;
}

function isConstructorIframeContext() {
    const params = new URLSearchParams(window.location.search);
    const hasOriginParam = Boolean(params.get('examus-client-origin'));
    let isFramed = false;
    let isTopLevel = true;
    let referrerHost = '';

    try {
        isFramed = window.parent !== window;
    } catch (_) {
        isFramed = true;
    }

    try {
        isTopLevel = window.self === window.top;
    } catch (_) {
        isTopLevel = false;
    }

    try {
        referrerHost = new URL(document.referrer || '').hostname.toLowerCase();
    } catch (_) {
        referrerHost = '';
    }

    const byReferrer = referrerHost.endsWith('.proctor.constructor.app');
    const byUserAgent = hasConstructorUserAgentHint() && isConstructorExternalProctoringEnabled(link_status);
    const result = hasOriginParam || isFramed || !isTopLevel || byReferrer || byUserAgent;

    if (!constructorIframeContextLogged) {
        constructorIframeContextLogged = true;
        console.log('[Constructor][mathtest] iframe context detect', {
            hasOriginParam,
            isFramed,
            isTopLevel,
            referrerHost,
            byUserAgent,
            result,
        });
        renderConstructorRuntimeDebug('iframe_context_detect', {
            hasOriginParam,
            isFramed,
            isTopLevel,
            referrerHost,
            byUserAgent,
            result,
        });
    }

    if (hasOriginParam) {
        return true;
    }
    if (isFramed || !isTopLevel) {
        return true;
    }
    if (byReferrer) {
        return true;
    }
    if (byUserAgent) {
        return true;
    }
    return false;
}

async function redirectToConstructorStart() {
    const startData = await studApi.get_constructor_start_redirect();
    if (!startData || startData.status === 'error') {
        throw new Error(startData?.msg || 'Failed to prepare Constructor start redirect');
    }
    submitConstructorStartForm(startData);
}


async function reallyStartTheTest() {
    studApi.test_event(EVENT_TYPE.STARTING_TEST);
    let res;
    try {
        res = await studApi.start_math_test();
    } catch (error) {
        setReadyButtonLoading(false);
        showStartError(error?.message || String(error));
        return;
    }
    link_status = await studApi.get_test_link_status();
    handleFullscreenChange();
    console.warn({link_status});
    renderConstructorRuntimeDebug('after_start_math_test', {
        startResponseStatus: res?.status || null,
    });
    if (res.status === "success") {
        if (isConstructorExternalProctoringEnabled(link_status)) {
            if (isConstructorIframeContext()) {
                await showStartedExamView();
                return;
            }
            try {
                await redirectToConstructorStart();
                return;
            } catch (error) {
                const message = error?.message || String(error);
                studApi.test_event(EVENT_TYPE.PROCTORING_SCREENSHOT_FAIL, null, message);
                setReadyButtonLoading(false);
                showStartError(`External Proctoring Error: ${message}`);
                return;
            }
        } else if (link_status?.need_proctoring) {
            setReadyButtonLoading(false);
            const message = `Unsupported external proctoring provider: ${link_status?.external_proctoring_provider || 'unknown'}`;
            showStartError(message);
            return;
        } else {
            await showStartedExamView();
        }
    } else if (res.status === "need_upload") {
        await handlePostExamStatusTransition({forceFinish: false, source: 'start_math_test_need_upload'});
    } else if (res.status === "too_early") {
        const activeInterval = `${cvtTs(link_status.start_available)}–${cvtTs(link_status.end_available)} (${getTimeZone()})`;
        setReadyButtonLoading(false);
        showStartError(`Too early!\nStart is possible only in interval ${activeInterval}`);
    } else if (res.status === "too_late") {
        const activeInterval = `${cvtTs(link_status.start_available)}–${cvtTs(link_status.end_available)} (${getTimeZone()})`;
        setReadyButtonLoading(false);
        showStartError(`Too Late!\nStart is possible only in interval ${activeInterval}`);
    } else if (res.status === "error") {
        setReadyButtonLoading(false);
        showStartError(res.msg || 'Failed to start exam');
    } else {
        window.location.reload();
    }
}


async function showStartedExamView() {
    clearWrittenUploadStatusPolling();
    if (isConstructorExternalProctoringEnabled(link_status)) {
        const guardReady = await ensureConstructorIframeGuardReady('show_started_exam_view');
        if (!guardReady) {
            return;
        }
        await ensureConstructorProctorStartedSynced('show_started_exam_view');
    }
    hidePostFinishMessage();
    console.log('[Constructor][mathtest] Rendering started exam view', {
        state: link_status?.state,
        need_proctoring: link_status?.need_proctoring,
        need_answer_input: link_status?.need_answer_input,
    });
    showTimeoutHeader(link_status, false);
    setDisplay(qrcode_wrapper, 'none');
    setDisplay(test_finished, 'none');
    await showExamLayout(link_status);
    if (isInternalProctoringEnabled(link_status)) {
        await startInternalProctoring(link_status);
    }
}

function updateTimer(left_seconds) {
    if (timerAnimationFrameId) {
        cancelAnimationFrame(timerAnimationFrameId);
        timerAnimationFrameId = null;
    }
    const startTime = performance.now();
    const endTime = startTime + left_seconds * 1000;

    function formatTime(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = Math.floor(seconds % 60);
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }

    function tick() {
        const now = performance.now();
        const remainingTime = Math.max(0, Math.round((endTime - now) / 1000));

        time_left.textContent = formatTime(remainingTime);

        if (remainingTime > 0) {
            timerAnimationFrameId = requestAnimationFrame(tick);
        } else {
            time_left.textContent = "00:00:00";
            timerAnimationFrameId = null;
        }
    }

    tick();
}

function scheduleStatusTransitionCheck(leftSeconds, sourceLabel) {
    clearStatusTransitionTimer();
    if (!Number.isFinite(leftSeconds) || leftSeconds >= 3600 * 24) {
        return;
    }
    const timeoutMs = Math.max(0, (leftSeconds + 2) * 1000);
    statusTransitionTimer = setTimeout(() => {
        handlePostExamStatusTransition({forceFinish: false, source: sourceLabel}).catch((error) => {
            console.error('[Constructor][mathtest] status transition timer failed', error);
        });
    }, timeoutMs);
}

function showTimeoutHeader(link_status, hideFinish) {
    const leftSeconds = Number(link_status?.left_seconds || 0);
    updateTimer(leftSeconds);
    scheduleStatusTransitionCheck(leftSeconds, 'timeout_reached');
    header.style.display = "none";
    header_rep.style.display = "flex";
    start_time.innerText = cvtTsOnlyTime(link_status.started_at);
    end_time.innerText = cvtTsOnlyTime(link_status.to_be_finished_at);
    test_status.style.display = "flex";
    if (hideFinish) {
        finish_test.style.display = 'none';
    } else {
        finish_test.style.display = 'flex';
    }
}

function clearProblemsFromDom() {
    problems_wrapper.innerHTML = '';
    setDisplay(written_instuctions, 'none');
    setDisplay(written_instuctions_after, 'none');
}

async function applyWrittenUploadState() {
    clearStatusTransitionTimer();
    clearProblemsFromDom();
    if (isConstructorExternalProctoringEnabled(link_status)) {
        if (!isConstructorIframeContext()) {
            try {
                showPostFinishMessage('Re-opening Constructor proctoring session...');
                await redirectToConstructorStart();
                return;
            } catch (error) {
                showPostFinishMessage(`Failed to reopen Constructor proctoring: ${getErrorText(error)}`, true);
                return;
            }
        }
        const guardReady = await ensureConstructorIframeGuardReady('apply_written_upload_state');
        if (!guardReady) {
            return;
        }
        await ensureConstructorProctorStartedSynced('apply_written_upload_state');
        hidePostFinishMessage();
    } else {
        hidePostFinishMessage();
    }
    await showQRcode();
    startWrittenUploadStatusPolling();
}

async function applyFinishedState() {
    clearStatusTransitionTimer();
    clearWrittenUploadStatusPolling();
    if (isConstructorExternalProctoringEnabled(link_status)) {
        await ensureConstructorSessionFinishedByLms('apply_finished_state');
    }
    clearProblemsFromDom();
    if (isInternalProctoringEnabled(link_status)) {
        stopInternalProctoring();
    }
    exitFullScreen();
    loading.style.display = 'none';
    mathTestIntro.style.display = 'none';
    testInstruction.style.display = 'none';
    testRulesBlock.style.display = 'none';
    finish_modal.style.display = "none";
    setProblemsVisible(false);
    setDisplay(qrcode_wrapper, 'none');
    header.style.display = "flex";
    header_rep.style.display = "none";
    test_status.style.display = "none";
    setDisplay(test_finished, 'block');
    hidePostFinishMessage();
}

async function applyStartedStateAfterRecheck() {
    clearWrittenUploadStatusPolling();
    hidePostFinishMessage();
    if (!isConstructorExternalProctoringEnabled(link_status) || isConstructorIframeContext()) {
        await showStartedExamView();
        return;
    }
    try {
        showPostFinishMessage('Re-opening Constructor proctoring session...');
        await redirectToConstructorStart();
    } catch (error) {
        showPostFinishMessage(`Failed to reopen Constructor proctoring: ${getErrorText(error)}`, true);
    }
}

async function handlePostExamStatusTransition({forceFinish = false, source = 'unknown'} = {}) {
    if (statusRecoveryInProgress) {
        console.log('[Constructor][mathtest] status recovery already in progress', {source});
        return;
    }
    statusRecoveryInProgress = true;
    clearStatusTransitionTimer();

    try {
        let initialStatus = null;
        if (forceFinish) {
            showPostFinishMessage('Finalizing exam in LMS...');
            try {
                initialStatus = await studApi.finish_exam();
                if (isConstructorExternalProctoringEnabled(link_status)) {
                    showPostFinishMessage('LMS finish accepted. Waiting for stable status from backend...');
                }
            } catch (error) {
                showPostFinishMessage(`Waiting for status sync: ${getErrorText(error)}`, true);
            }
        }

        while (true) {
            let nextStatus = initialStatus;
            initialStatus = null;
            if (!nextStatus || !nextStatus.state) {
                try {
                    nextStatus = await studApi.get_test_link_status();
                } catch (error) {
                    showPostFinishMessage(`Waiting for server status. Error: ${getErrorText(error)}`, true);
                    await sleep(2500);
                    continue;
                }
            }

            if (!nextStatus || !nextStatus.state) {
                showPostFinishMessage('Waiting for server status update...');
                await sleep(2500);
                continue;
            }

            link_status = nextStatus;
            handleFullscreenChange();
            console.log('[Constructor][mathtest] post-finish status recheck', {
                source,
                state: link_status.state,
                left_seconds: link_status.left_seconds,
            });

            if (link_status.state === TEST_LINK_STATE.STARTED_NOT_FINISHED) {
                await applyStartedStateAfterRecheck();
                return;
            }
            if (link_status.state === TEST_LINK_STATE.FIN_WRITTEN_UPLOAD) {
                await applyWrittenUploadState();
                return;
            }
            if (link_status.state === TEST_LINK_STATE.FINISHED) {
                try {
                    await applyFinishedState();
                    return;
                } catch (error) {
                    showPostFinishMessage(`Waiting for finish synchronization: ${getErrorText(error)}`, true);
                    await sleep(2500);
                    continue;
                }
            }

            showPostFinishMessage(`Waiting for stable status from backend. Current state: ${link_status.state}`);
            await sleep(2500);
        }
    } finally {
        statusRecoveryInProgress = false;
    }
}

async function ansSaverFunc(answer, test_instance_task_id, onlyLog = false) {
    try {
        if (shouldManageFullscreenByHost(link_status)) {
            enterFullscreen();
        }
    } catch (e) {
    }
    studApi.test_event(EVENT_TYPE.ANSWER_SENT, test_instance_task_id, answer);
    if (!onlyLog) {
        return await studApi.save_task_answer(answer, test_instance_task_id);
    }
}

async function showExamLayout(link_status) {
    const alreadyRendered = problems_wrapper.children.length > 0;
    let problems = [];
    if (!alreadyRendered) {
        problems = await studApi.get_problems_to_solve();
    }
    if (shouldManageFullscreenByHost(link_status)) {
        enterFullscreen();
    }
    logInteractionDiagnostics('show_exam_layout');
    if (link_status?.iframe_url) {
        location.href = link_status.iframe_url;
    } else if (!alreadyRendered) {
        for (let prob of problems) {
            let pc = new ProblemComponent(
                problems_wrapper,
                prob,
                studApi.token,
                ansSaverFunc,
                link_status.need_answer_input,
            )
        }
    }
    // Трешняк, конечно. Письменность экзамена кодируется в need_answer_input о_О
    if (!link_status.need_answer_input) {
        setDisplay(written_instuctions, 'block');
        setDisplay(written_instuctions_after, 'block');
    }
    loading.style.display = 'none';
    mathTestIntro.style.display = 'none';
    testInstruction.style.display = 'none';
    testRulesBlock.style.display = 'none';
    setProblemsVisible(true);
    finish_test.style.display = 'flex';
}

finish_test.addEventListener("click", () => {
    studApi.test_event(EVENT_TYPE.FINISH_PRESSED);
    finish_modal.style.display = "flex";
});
cancel_finish.addEventListener("click", () => {
    studApi.test_event(EVENT_TYPE.FINISH_CANCEL);
    finish_modal.style.display = "none";
});
confirm_finish.addEventListener("click", async () => {
    studApi.test_event(EVENT_TYPE.FINISH_APPROVE);
    finish_modal.style.display = "none";
    showPostFinishMessage('Finalizing exam status...');
    await handlePostExamStatusTransition({forceFinish: true, source: 'finish_button'});
});


// Обработчик переключения вкладок/окон через Page Visibility API
function handleVisibilityChange() {
    if (document.hidden) {
        studApi.test_event(EVENT_TYPE.FOCUS_LOST);
    } else {
        studApi.test_event(EVENT_TYPE.FOCUS_GAINED);
    }
}

// Дополнительные обработчики для blur/focus окна
function handleWindowBlur() {
    studApi.test_event(EVENT_TYPE.FOCUS_LOST);
}

function handleWindowFocus() {
    studApi.test_event(EVENT_TYPE.FOCUS_GAINED);
}

// Обработчик события копирования
function handleCopy(e) {
    const selectedText = window.getSelection().toString();
    studApi.test_event(EVENT_TYPE.COPY, null, selectedText);
}

// Обработчик события вставки
function handlePaste(e) {
    const pastedData = (e.clipboardData || window.clipboardData).getData('text');
    studApi.test_event(EVENT_TYPE.PASTE, null, pastedData);
}

// Назначаем обработчики событий
document.addEventListener('visibilitychange', handleVisibilityChange);
window.addEventListener('blur', handleWindowBlur);
window.addEventListener('focus', handleWindowFocus);
document.addEventListener('copy', handleCopy);
document.addEventListener('paste', handlePaste);


// Отслеживаем изменения размера экрана
let resizeTimer;

function onResize() {
    // Сброс предыдущего таймера
    clearTimeout(resizeTimer);
    // Установка нового таймера на 250 мс
    resizeTimer = setTimeout(() => {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        studApi.test_event(EVENT_TYPE.RESIZE, null, `${newWidth}×${newHeight}`);
        applyCameraPreviewVisibility();
    }, 250);
}

window.addEventListener('resize', onResize);
document.addEventListener('fullscreenchange', onResize);
document.addEventListener('fullscreenchange', handleFullscreenChange);
document.addEventListener('webkitfullscreenchange', onResize);
document.addEventListener('mozfullscreenchange', onResize);
document.addEventListener('MSFullscreenChange', onResize);

document.addEventListener('contextmenu', function (e) {
    e.preventDefault(); // Можно предотвратить открытие меню, если это допустимо
    studApi.test_event(EVENT_TYPE.CONTEXTMENU,);
});

window.addEventListener('beforeunload', function () {
    studApi.test_event(EVENT_TYPE.UNLOAD, null, 'Page unloading');
    if (isConstructorSecureBrowserRuntime(link_status) && ACTIVE_FULLSCREEN_PILL_STATES.has(link_status?.state)) {
        const msg = 'Leaving this page will stop proctoring. Are you sure you want to leave?';
        if (window.event) {
            window.event.returnValue = msg;
        }
        return msg;
    }
    if (isInternalProctoringEnabled(link_status)) {
        stopInternalProctoring();
    }
});

document.addEventListener('keydown', function (e) {
    // Получаем числовой код клавиши (для старых браузеров)
    const keyCode = e.keyCode || e.which;
    // Пытаемся получить значение клавиши (если поддерживается)
    const key = e.key ? e.key.toUpperCase() : String.fromCharCode(keyCode);

    // Проверка на F12: либо e.key равен "F12", либо keyCode равен 123
    const isF12 = (e.key && e.key === 'F12') || (keyCode === 123);

    // Проверка комбинации Ctrl+Shift+(I, J, C)
    const allowedKeys = ['I', 'J', 'C'];
    const isCheatingCombo = e.ctrlKey && e.shiftKey && (
        (e.key && allowedKeys.includes(e.key.toUpperCase())) ||
        (keyCode === 73 || keyCode === 74 || keyCode === 67)
    );

    if (isF12 || isCheatingCombo) {
        // Если F12, то используем "F12", иначе берем букву (уже приведенную к верхнему регистру)
        const pressedKey = isF12 ? 'F12' : key;
        studApi.test_event(EVENT_TYPE.KEYDOWN, null, `Cheating: ${pressedKey}`);
    }
});


let devtoolsOpen = false;
let devtoolsOrientation = null;
const threshold = 160; // Порог для определения открытых devtools

function detectDevTools() {
    // Разница между внешней и внутренней шириной/высотой окна
    const widthDiff = window.outerWidth - window.innerWidth;
    const heightDiff = window.outerHeight - window.innerHeight;
    let isDevtoolsOpen = false;
    let orientation = null;

    if (widthDiff > threshold) {
        isDevtoolsOpen = true;
        orientation = 'vertical';
    } else if (heightDiff > threshold) {
        isDevtoolsOpen = true;
        orientation = 'horizontal';
    }

    if (isDevtoolsOpen && !devtoolsOpen) {
        devtoolsOpen = true;
        devtoolsOrientation = orientation;
        studApi.test_event(EVENT_TYPE.DEVTOOLS, null, `open (${orientation})`);
    } else if (!isDevtoolsOpen && devtoolsOpen) {
        devtoolsOpen = false;
        devtoolsOrientation = null;
        studApi.test_event(EVENT_TYPE.DEVTOOLS, null, 'closed');
    }
}

// Проверяем состояние devtools каждые 500 мс
setInterval(detectDevTools, 500);
